/**
 * Popper.js custom modifier
 * - Reposition the dropdown to be directly below the cell.
 * - The left position is off due to the width of the popper not
 * matching the cell width. Reposition it once the width is set.
 */
export const repositionModifier = {
  name: 'repositionModifier',
  enabled: true,
  phase: 'beforeWrite',
  requires: ['computeStyles'],
  fn: data => {
    const popperPaperNode = data.state.elements.popper.childNodes[0]
    const { reference } = data.state.elements
    const { y, height } = data.state.rects.reference
    const { left } = getOffset(reference)
    const width = popperPaperNode?.offsetWidth
    const topPosition = Math.floor(y + height)

    data.state.styles.popper.width = `${width}px`
    data.state.styles.popper.transform = `translate3d(${left}px, ${topPosition}px, 0)`
  },
}

/**
 * Get the offset position of an element.
 * @param el HTML Element
 * @returns {{ left: number, top: number }} Offset positions of element.
 */
function getOffset(el) {
  const rect = el.getBoundingClientRect()
  return {
    left: rect.left + window.scrollX,
    top: rect.top + window.scrollY,
  }
}
